import React, { Component } from "react";
import moment from "moment";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import routes from "../../routes/URL";
import { Button, TextField, CardContent, CardHeader, Box, Typography, Container, Select, MenuItem, TextareaAutosize } from "@mui/material";
import Toast from "../../components/Toast";
import Header from "../../components/Header";

class CreateScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      heading: "",
      points: "",
      processedPoints: [],
      activeTickets: [],
      toast: {
        open: false,
        message: "",
        severity: "success" // default severity
      }
    };
  }
  
  componentDidMount() {
    this.getAllActiveTickets();
  }
  
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ toast: { ...this.state.toast, open: false } });
  };

  getAllActiveTickets = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getAllActiveTickets
    );
    if (status == "success") {
      this.setState({ activeTickets: data.data });
    }
  };

  saveData = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.submitTicket,
      formData
    );
    if (status == "success") {
      return this.props.history.push(routes.admin.support.detail(this.props.hotels[0]?.hotel_slug || '',data.id));
    } else {
      this.showToast(message, "error");
    }
  }; 
  
  render() {
    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{ 
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        > 
          <CardHeader
            title={<Header title="Open Ticket" />}
            sx={{ pb: 2 }}
          />
          
          <CardContent sx={{}}>
            <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={4}>
              {/* Form Section */}
              <Box flex={2}>
                <form
                  id="ticketForm"
                  name="ticketForm"
                  onSubmit={(e) => this.saveData(e)}
                >
                  <Box mb={3}>
                    <TextField
                      fullWidth
                      id="subject"
                      name="subject"
                      label="Subject"
                      placeholder="Enter subject"
                      variant="outlined"
                      required
                      onChange={(e) => {
                        this.setState({
                          heading: e.target.value,
                        });
                      }}
                      InputProps={{
                        sx: {
                          borderRadius: 1,
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white !important',
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          '&.Mui-focused': {
                            color: 'white !important',
                          },
                        },
                      }}
                    />
                  </Box>

                <Box mb={3}>
  <TextField
    select
    fullWidth
    id="type"
    name="type"
    label="Type"
    variant="outlined"
    required
    value={this.state.type || ''}
    onChange={(e) => {
      this.setState({
        type: e.target.value,
      });
    }}
    InputProps={{
      sx: {
        borderRadius: 1,
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'white !important',
        },
      },
    }}
    InputLabelProps={{
      sx: {
        '&.Mui-focused': {
          color: 'white !important',
        },
      },
    }}
  >
    <MenuItem disabled value="">
      <em>Select ticket type</em>
    </MenuItem>
    <MenuItem value="support">Support</MenuItem>
    <MenuItem value="complaint">Complaint</MenuItem>
    <MenuItem value="suggestion">Suggestion</MenuItem>
  </TextField>
</Box>

                  <Box mb={3}>
                    <TextField
                      fullWidth
                      id="description"
                      name="description"
                      label="Message"
                      placeholder="Enter your message"
                      variant="outlined"
                      multiline
                      rows={4}
                      required
                      onChange={async (e) => {
                        const points = e.target.value;
                        const processedPoints = points
                          .split("\n")
                          .filter((item) => item !== "");

                        this.setState({
                          points: e.target.value,
                          processedPoints,
                        });
                      }}
                      InputProps={{
                        sx: {
                          borderRadius: 1,
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white !important',
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          '&.Mui-focused': {
                            color: 'white !important',
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box mt={4} display="flex" justifyContent="flex-start">
                    <Button
                      variant="contained"
                      type="submit"
                      size="large"
                      sx={{
                        px: 4,
                        py: 1,
                        borderRadius: 1,
                        textTransform: "none",
                        fontWeight: 700,
                        bgcolor: "#FFC857",
                        "&:hover": {
                          bgcolor: "#E6B54E",
                        },
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                </form>
              </Box>

              {/* Recent Tickets Section */}
              <Box flex={1}>
                <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                  Your Recent Tickets
                </Typography>
                
                <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                  {this.state.activeTickets.map((item) => (
                    <Box
                      key={item.id}
                      sx={{
                        cursor: "pointer",
                        p: 2,
                        mb: 2,
                        borderRadius: 1,
                        backgroundColor: '#041A29',
                        '&:hover': {
                          backgroundColor: '#041A29',
                        },
                      }}
                      onClick={() => {
                        this.props.history.push(routes.admin.support.detail(this.props.hotels[0]?.hotel_slug ,item.id));
                      }}
                    >
                      <Typography variant="subtitle1">
                        #{item.id} - {item.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {moment(item.created_at).format("DD-MM-YYYY hh:mm A")}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  size="medium"
                  sx={{
                    mt: 2,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": {
                      bgcolor: "#E6B54E",
                    },
                  }}
                  onClick={() => {
                    this.props.history.push(routes.admin.support.root(this.props.hotels[0]?.hotel_slug || ''));
                  }}
                >
                  View All
                </Button>
              </Box>
            </Box>
          </CardContent>
        </Box>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Container>
    );
  }
}

export default redux(CreateScreen);